<template>
  <div>
    <!-- 添加标签对话框 -->
    <el-dialog
        title="添加标签"
        :visible.sync="addDialogVisible"
        width="40%"
        append-to-body
        @close="addDialogClosed"
    >
      <el-form
          ref="addFormRef"
          :model="addForm"
          :rules="rules"
          label-width="80px"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="名称" prop="name">
              <el-input v-model="addForm.name" placeholder="请输入名称"/>
            </el-form-item>
          </el-col>

          <!--<el-col :span="12">
            <el-form-item label="是否启用" prop="enumEnable">
              <el-select v-model="addForm.enumEnable" clearable placeholder="请选择是否启用" style="width: 100%">
                <el-option key="NORMAL" label="是" value="NORMAL"></el-option>
                <el-option key="DISABLE" label="否" value="DISABLE"></el-option>
              </el-select>
            </el-form-item>
          </el-col>-->

          <el-col :span="24">
            <el-form-item label="图标" prop="icon">
              <picture-icon v-model="addForm.icon"></picture-icon>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addLabel">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {addLabel} from "@/api/label/label";
import {getData} from "@/utils/code";
import PictureIcon from '@/components/common/picture/pictureIcon'
import { labelRules } from '@/js/rules'

export default {
  name: "addLabel",
  components: { PictureIcon },
  data() {
    return {
      addForm: {
        enumEnable: 'NORMAL'
      },
      addDialogVisible: false,
      // 规则
      rules: labelRules
    }
  },
  methods: {
    cancel() {
      this.addDialogVisible = false
      this.addForm = {}
    },

    addDialog() {
      this.addDialogVisible = true
    },

    // 监听添加用户对话框的关闭事件 /  重置表单
    addDialogClosed() {
      this.addForm = {}
    },

    // 添加
    addLabel() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return;
        addLabel(this.addForm).then((response) => {
          let data = getData(response)
          if (data !== null) {
            this.$emit('refresh-list')
            this.addDialogVisible = false;
          }
        })
      });
    },

  }
}
</script>

<style scoped lang="less">
/deep/.el-input {
  width: 90%;
}
</style>
